<template>
  <div class="relative group">
    <component
      :is="to ? 'router-link' : 'div'"
      :to="to"
      :class="[
        'block p-6 bg-white rounded-lg shadow-md border border-gray-200',
        !disabled && to
          ? 'hover:shadow-lg hover:border-bdc-ocre transition-all duration-200 cursor-pointer'
          : '',
        disabled ? 'opacity-50 cursor-not-allowed' : '',
      ]"
    >
      <div class="flex items-center space-x-4">
        <div class="flex-shrink-0">
          <div
            :class="[
              'w-12 h-12 rounded-lg flex items-center justify-center transition-colors',
              iconBgClasses,
            ]"
          >
            <component
              :is="icon"
              :class="['w-6 h-6', !disabled ? iconColor || 'text-bdc-ocre' : 'text-gray-400']"
            />
          </div>
        </div>
        <div class="flex-1 min-w-0">
          <h3
            :class="[
              'text-sm font-semibold transition-colors',
              !disabled ? 'text-bdc-black group-hover:text-bdc-ocre' : 'text-gray-400',
            ]"
          >
            {{ title }}
          </h3>
        </div>
        <div class="flex-shrink-0" v-if="!disabled && to">
          <ChevronRight class="w-5 h-5 text-gray-400 group-hover:text-bdc-ocre transition-colors" />
        </div>
      </div>
    </component>

    <!-- Tooltip -->
    <div
      v-if="description"
      class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal max-w-xs z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none"
    >
      {{ description }}
      <!-- Flèche du tooltip -->
      <div
        class="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-transparent border-t-gray-900"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChevronRight } from 'lucide-vue-next'
import { computed } from 'vue'

interface Props {
  title: string
  description: string
  icon: any
  to?: string
  disabled?: boolean
  iconColor?: string
  iconBgColor?: string
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})

const iconBgClasses = computed(() => {
  if (props.disabled) return 'bg-gray-100'
  if (!props.iconBgColor) return 'bg-bdc-ocre/10 group-hover:bg-bdc-ocre/20'

  // Gérer les différentes couleurs avec leurs variantes hover
  if (props.iconBgColor === 'bg-bdc-ocre/10') return 'bg-bdc-ocre/10 group-hover:bg-bdc-ocre/20'
  if (props.iconBgColor === 'bg-bdc-terracotta/10')
    return 'bg-bdc-terracotta/10 group-hover:bg-bdc-terracotta/20'
  if (props.iconBgColor === 'bg-bdc-black/10') return 'bg-bdc-black/10 group-hover:bg-bdc-black/20'

  return props.iconBgColor
})
</script>
